export default "__VITE_ASSET__CNzQRLDP__"